import { FC } from "react";
import styles from "./Tickets.module.sass";
import classNames from "classnames/dedupe";
import { Button } from "../../../../components/Button";
import { Container } from "../../../../components/Container";

export const Tickets: FC = () => {
  return (
    <Container id="tickets" className={classNames(styles.root)}>
      <div
        className={classNames(
          "df-center fd-column",
          styles.ticket,
          styles.ticket1,
        )}
      >
        <span aria-hidden="true" className={classNames(styles.dot, styles.blueDot)} />
        <div className={styles.container}>
          <div className={styles.header}>
            <h3 className={styles.title}>BASIC</h3>
            <p className={styles.price}>3 000₴</p>
          </div>
          <div className={styles.content}>
            <ul className={styles.list}>
              <li className={styles.li}>Всі виступи на головній сцені</li>
              <li className={styles.li}>Фіксоване місце в залі</li>
              <li className={styles.li}>Доступ до телеграм-чату учасників</li>
              <li className={styles.li}>
                Доступ до презентацій спікерів протягом 1 місяця
              </li>
              <li className={styles.li}>Професійні фото з форуму</li>
              <li className={styles.li}>Кава-брейк і обід</li>
            </ul>
          </div>
        </div>
        <Button className={styles.button} />
      </div>
      <div
        className={classNames(
          "df-center fd-column",
          styles.ticket,
          styles.ticket2,
        )}
      >
        <span aria-hidden="true" className={classNames(styles.dot, styles.orangeDot)} />
        <div className={styles.container}>
          <div className={styles.header}>
            <h3 className={styles.title}>CHARITY</h3>
            <p className={styles.price}>3 900₴</p>
          </div>
          <div className={styles.content}>
            <ul className={styles.list}>
              <li className={styles.li}>
                30% від вартості квитка на благодійність
              </li>
              <li className={styles.li}>Всі виступи на головній сцені</li>
              <li className={styles.li}>Фіксоване місце в залі</li>
              <li className={styles.li}>Доступ до телеграм-чату учасників</li>
              <li className={styles.li}>
                Доступ до презентацій спікерів протягом 1 місяця
              </li>
              <li className={styles.li}>Професійні фото з форуму</li>
              <li className={styles.li}>Кава-брейк і обід</li>
              <li className={styles.li}>
                Вечірній нетворкінг по завершенню форуму
              </li>
            </ul>
          </div>
        </div>
        <Button className={styles.button} />
      </div>
      <div
        className={classNames(
          "df-center fd-column",
          styles.ticket,
          styles.ticket4,
        )}
      >
        <div className={styles.container}>
          <div className={styles.content}>
            <span>
              Для військових та ветеранів <strong>квиток безкоштовний</strong>
            </span>
            <Button
              className={styles.button}
              name="ДЛЯ ВІЙСЬКОВИХ"
              link="https://docs.google.com/forms/d/e/1FAIpQLSe46mZhjV-uPSv3j9iYtLq9BqHJZnD5jhfXYiJRHurQxmH7yQ/viewform"
              target="_blank"
            />
            <hr className={styles.divider} />
            <span>
              Масштабуйтесь командами: Купуючи <strong>4 квитки</strong> по
              рахунку, ви отримуєте <strong>5-й в подарунок</strong>
            </span>
            <Button
              className={styles.button}
              name="ОТРИМАТИ РАХУНОК"
              link="https://forms.gle/PPYjSt6hjcCZBGTv6"
              target="_blank"
            />
          </div>
        </div>
      </div>
      <div className={styles.darkDot}></div>
      <div className={styles.lightDot}></div>
    </Container>
  );
};
